import {
  FigureViewHome
} from '../../components';
import { StyledBroadsiderHud } from './BroadsiderHud.styled';
import BroadsiderHomeHudBanner from './BroadsiderHomeHudBanner';
import { useEffect, useState } from 'react';
import { FigureModel } from '../../models';
import useIsMobile from '../../hooks/useIsMobile';

const ExpandMetaversePopup = ({ onClick }) => {
  return (
    <div className='expand-metaverse' onClick={onClick}>
      <div className='expand-metaverse-button'>
        <img src='/assets/try_right.svg' /> 
        <div className='expand-metaverse-button-text'>
	  Explore
        </div>
        <img src='/assets/try_right.svg' /> 
      </div>
    </div>
  );
};

const HOMESCREEN_MODELS = [ 
  {
    id: '0000',
    name: 'Default',
    vrm: '/assets/default_avatar.vrm',
    glb: '/assets/default_avatar.vrm',
    image: '/assets/default_avatar.png'
  },
  {
    id: '61685',
    name: 'Stinger',
    vrm: '/assets/stinger_avatar.vrm',
    glb: '/assets/stinger_avatar.vrm',
    image: '/assets/stinger_avatar.png'
  },
  {
    id: '2969',
    name: 'Sophia',
    vrm: '/assets/sophia_avatar.vrm',
    glb: '/assets/sophia_avatar.vrm',
    image: '/assets/sophia_avatar.png'
  },
  {
    id: 'STAGE 01',
    name: 'MESH',
    vrm: '/assets/mesh_avatar.vrm',
    glb: '/assets/mesh_avatar.vrm',
    image: '/assets/mesh_avatar.png'
  },
  {
    id: 'STAGE 02',
    name: 'Default',
    vrm: '/assets/avatar3.vrm',
    glb: '/assets/avatar3.vrm',
    image: '/assets/default_avatar.png'
  },
  {
    id: 'STAGE 03',
    name: 'Full',
    vrm: '/assets/full_avatar_2.vrm',
    glb: '/assets/full_avatar_2.vrm',
    image: '/assets/full_avatar.png'
  }
];


const BroadsiderHomeHud = ({ figures, metaverseData = [], selectedBroadsider, selectedIndex }) => {
  //const [selectedBroadsider, setSelectedBroadsider] = useState(figures[0]);
  const [collapsed, setCollapsed] = useState(false);
  const isMobile = useIsMobile();
  const controls = {};

  const applyCollapsed = (clp) => {
    controls.homeAvatar(clp);
    setCollapsed(clp);
  };
  useEffect(() => {
    if (selectedIndex === 1 && controls.selectFigure1) controls.selectFigure1(); 
    if (selectedIndex === 2 && controls.selectFigure2) controls.selectFigure2(); 
    if (selectedIndex === 3 && controls.selectFigure3) controls.selectFigure3(); 
  }, [selectedIndex]);

  return (
    <StyledBroadsiderHud>
      <FigureViewHome
        selectedIndex={selectedIndex}
        figure1={figures[0]}
        figure2={figures[1]}
        figure3={figures[2]}
        figure4={figures[3]}
        figure5={figures[4]}
        figure6={figures[5]}
        controls={controls}
        noDecorators
        width='100%'
        height='100%'
      />
    </StyledBroadsiderHud>
  );
};

export default BroadsiderHomeHud;
